import { Button, Stack } from '@chakra-ui/react'
import type { Dispatch, SetStateAction } from 'react'

import ModalV3 from '@/components/UI/Modal/ModalV3'

export default function CourseFollowModal({
  followButton,
  FollowTopicBody,
  modalIsOpen,
  setModalIsOpen,
  courseName,
  onSubmit,
}: {
  followButton: React.ReactElement
  FollowTopicBody: React.FC
  modalIsOpen: boolean
  setModalIsOpen: Dispatch<SetStateAction<boolean>>
  courseName: string | null
  onSubmit: () => void
}): JSX.Element | null {
  return (
    <>
      {followButton}
      <ModalV3
        open={modalIsOpen}
        title={`Follow ${courseName} Topics`}
        onClose={() => setModalIsOpen(false)}
        size="3xl"
        body={() => <FollowTopicBody />}
        rightFooterContent={() => (
          <Stack direction="row" spacing="8px">
            <Button variant="outline" onClick={() => setModalIsOpen(false)}>
              Cancel
            </Button>
            <Button onClick={onSubmit}>Apply</Button>
          </Stack>
        )}
      />
    </>
  )
}
